// extracted by mini-css-extract-plugin
export default {"main_navbar":"Navbar_main_navbar__fqXsv","navbar__change":"Navbar_navbar__change__jm9RT","nav_components":"Navbar_nav_components__2lzrs"};